export default __webpack_public_path__ + "upload/logo.768d3adc.svg";